module.exports = __webpack_public_path__ + "static/media/multipla-escolha-icon.0f04591f.svg";